import {DataStoreAbstract} from "./DataStoreAbstract";
import {ApiResponse} from "../models/ApiResponse";

export class BaseServiceAbstract {

    dataStore?: DataStoreAbstract;
    isCurrentlyLoggedIn?: boolean = null;

    apiHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '',
    };

    constructor(dataStore?: DataStoreAbstract, public loginUrl?: string) {
        this.dataStore = dataStore;
    }

    /**
     * get auth header with bearer token.
     */
    getAuthHeader() {
        return this.apiHeaders;
    }

    addHeader(key: string, value: string) {
        let newHeader: any = {}
        newHeader[key] = value;
        this.apiHeaders = Object.assign(this.apiHeaders, newHeader);
    }

    /**
     * convert response to api response type.
     * Needed vor json api promises.
     * @param res
     */
    async factoryApiResponse(res: Response): Promise<ApiResponse> {
        return new Promise<ApiResponse>((resolve, reject) => {
            res.json().then(json => {
                let success = true;
                if (res.status !== 200) {
                    success = false;
                    // session timeout, nav to login
                    if (res.status === 419 && this.loginUrl) {
                        window.location.href = this.loginUrl;
                    }
                }
                resolve(new ApiResponse(success, json));
            }).catch((e) => {
                console.warn(e);
                resolve(new ApiResponse(false, {}));
            });
        });
    }

    /**
     * convert response stream to api response type.
     * @param res
     */
    factoryApiResponseStream(res: Response): Promise<ApiResponse> {
        return new Promise<ApiResponse>((resolve, reject) => {
            if (res.status === 200) {
                res.blob().then(blob => {
                    resolve(new ApiResponse(true, blob));
                }).catch((e) => {
                    console.warn(e);
                    resolve(new ApiResponse(false, {}));
                });
            } else {
                res.json().then(json => {
                    reject(new ApiResponse(false, json));
                })
            }
        });
    }

    /**
     * success promise api call.
     * @param apiResponse
     * @param resolve
     * @param reject
     */
    success(apiResponse: ApiResponse, resolve: Function, reject: Function) {
        if (apiResponse.success) {
            resolve(apiResponse);
        } else {
            reject(apiResponse);
        }
    }

    /**
     * Dateiname aus header attachment auslesen
     * @param response
     */
    getFileNameFromResponse(response: Response): string {
        let filename = "";
        response.headers.forEach(function (val, key) {
            if (val && val.indexOf('attachment') !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(val);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
        });
        return filename;
    }
}
